module.exports = __webpack_public_path__ + "img/g5.ba327dd3.png";